import { lang } from '@dhxete/utill';

export default lang;